import React from "react";

const SvgReportingLine = props => (
  <svg className="reporting__line" viewBox="0 0 910 32" {...props}>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <polygon
        id="Rectangle"
        fill="#009EE3"
        points="0 0 900 0 910 16 900 32 0 32"
      />
      <g
        className="main-arrow-one"
        id="Group-9"
        transform="translate(7.000000, 9.000000)"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8,7 L243,7" id="Stroke-1" strokeDasharray="5 5" />
        <path
          d="M4,11 C6.21,11 8,9.208 8,7 C8,4.79 6.21,3 4,3 C1.79,3 0,4.79 0,7 C0,9.208 1.79,11 4,11 Z"
          id="Stroke-3"
        />
        <polyline id="Stroke-5" points="235 0 243 7.00093998 235 14" />
      </g>
      <g
        className="main-arrow-two"
        id="Group-9-Copy"
        transform="translate(307.000000, 9.000000)"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8,7 L243,7" id="Stroke-1" strokeDasharray="5 5" />
        <path
          d="M4,11 C6.21,11 8,9.208 8,7 C8,4.79 6.21,3 4,3 C1.79,3 0,4.79 0,7 C0,9.208 1.79,11 4,11 Z"
          id="Stroke-3"
        />
        <polyline id="Stroke-5" points="235 0 243 7.00093998 235 14" />
      </g>
      <g
        className="main-arrow-three"
        id="Group-9-Copy-2"
        transform="translate(629.000000, 9.000000)"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8,7 L243,7" id="Stroke-1" strokeDasharray="5 5" />
        <path
          d="M4,11 C6.21,11 8,9.208 8,7 C8,4.79 6.21,3 4,3 C1.79,3 0,4.79 0,7 C0,9.208 1.79,11 4,11 Z"
          id="Stroke-3"
        />
        <polyline id="Stroke-5" points="235 0 243 7.00093998 235 14" />
      </g>
    </g>
  </svg>
);

export default SvgReportingLine;




// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/ReportingLine.jsx